'use client';

import Image from 'next/image';

import Link from 'next/link';

import Button from '@gds/Button/Button';
import { Typography } from '@gds/Typography/Typography';

import sellMyCarHero from './Images/hero.png';

import styles from './SellMyCarBanner.module.css';

interface SellMyCarBannerProps {
  strings: Record<string, any>;
}

const SellMyCarBanner = ({ strings }: SellMyCarBannerProps) => {
  return (
    <article className={styles.banner}>
      <header>
        <Typography className={styles.title} variant={'h3'}>
          {strings.title}
        </Typography>
      </header>
      <div>
        <Image alt={strings.heroAlt} className={styles.image} src={sellMyCarHero} />
        <p>{strings.copy}</p>
        <Link href={`/de/verkaufen`}>
          <Button
            aria-label="sell-my-car-button"
            className={styles.button}
            fullWidth
            type="submit"
            variant="outlined"
          >
            {strings.buttonLabel}
          </Button>
        </Link>
      </div>
    </article>
  );
};

export default SellMyCarBanner;
